import { render, staticRenderFns } from "./formLgpd.vue?vue&type=template&id=632ef2b2&scoped=true"
import script from "./formLgpd.vue?vue&type=script&lang=js"
export * from "./formLgpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ef2b2",
  null
  
)

export default component.exports